import React, { useState } from "react";
import { Menu, Dropdown, Input, Avatar } from "antd";
import Typography from "../Typography";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import InfiniteScroll from "react-infinite-scroll-component";

const workspaceColorMap = ["#4555eb", "#209f85", "#fa694a", "#2c3e50", "#e74c3c"];

const PickWorkspaceColor = (word) => {
  if (!word) return "";
  const firstChar = word?.charAt(0)?.toLowerCase();
  const alphabetIndex = firstChar.charCodeAt(0) - "a".charCodeAt(0);
  const colorIndex = Math.floor(alphabetIndex / (26 / workspaceColorMap.length));
  return workspaceColorMap[colorIndex];
};

function formatString(str) {
  return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
}

const SearchDropdown = (props) => {
  const [searchText, setSearchText] = useState("");
  const [visible, setVisible] = useState(false);
  const [userDetails] = useRecoilState(userInfo);

  // filter items by search
  const filteredItems = (props.workspaces || []).filter((item) =>
    item?.name?.toLowerCase()?.includes(searchText?.toLowerCase())
  );

  // lazy loading states
  const [items, setItems] = useState(filteredItems.slice(0, 20));
  const [hasMore, setHasMore] = useState(filteredItems.length > 20);

  const loadMore = () => {
    if (items.length >= filteredItems.length) {
      setHasMore(false);
      return;
    }
    setTimeout(() => {
      setItems(filteredItems.slice(0, items.length + 20));
    }, 300); // simulate async
  };

  // reset list when search changes
  const handleSearch = (value) => {
    setSearchText(value);
    const newFiltered = (props.workspaces || []).filter((item) =>
      item?.name?.toLowerCase()?.includes(value?.toLowerCase())
    );
    setItems(newFiltered.slice(0, 20));
    setHasMore(newFiltered.length > 20);
  };

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const menu = (
    <Menu>
      <Menu.Item key="search">
        <Input
          placeholder="Search workspaces"
          onChange={(e) => handleSearch(e.target.value)}
          onClick={(e) => e.stopPropagation()} // keep dropdown open
          style={{ height: 32 }}
        />
      </Menu.Item>

      {/* Scrollable List */}
      <div id="scrollableDiv" style={{ maxHeight: 200, overflow: "auto" }}>
        <InfiniteScroll
          dataLength={items.length}
          next={loadMore}
          hasMore={hasMore}
          loader={<p style={{ textAlign: "center", margin: 8 }}>Loading...</p>}
          scrollableTarget="scrollableDiv"
        >
          {items.map((element) => (
            <Menu.Item key={element.key}>
              <div
                style={{ display: "flex", alignItems: "center", width: 170 }}
                onClick={() => props.handleSelectWorkspce(element)}
              >
                <div style={{ width: 28 }}>
                  <Avatar
                    size={22}
                    style={{
                      backgroundColor: PickWorkspaceColor(element.name),
                      marginRight: 6,
                    }}
                  >
                    <Typography variant="xs" style={{ color: "white" }}>
                      {`${element.name?.[0]}${element.name?.[1]}`}
                    </Typography>
                  </Avatar>
                </div>
                <p
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    color: "var(--text-color-black)",
                    fontSize: 12,
                  }}
                >
                  {/* {formatString(element.name)} */}
                  {element.name}
                </p>
              </div>
            </Menu.Item>
          ))}
        </InfiniteScroll>
      </div>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          overflow: "hidden",
        }}
      >
        <div style={{ width: 30 }}>
          <Avatar
            size={24}
            style={{
              backgroundColor: PickWorkspaceColor(userDetails?.currentWorkspace?.name),
              borderRadius: 8,
              marginRight: 6,
            }}
          >
            <Typography style={{ color: "white" }} variant="caption">
              {`${userDetails?.currentWorkspace?.name?.[0]}`}
            </Typography>
          </Avatar>
        </div>

        <Typography variant="caption">
          {/* {formatString(userDetails?.currentWorkspace?.name)} */}
          {userDetails?.currentWorkspace?.name}
        </Typography>

        <ExpandMoreRoundedIcon />
      </div>
    </Dropdown>
  );
};

export default SearchDropdown;


